
import { createContext } from 'react'

const navigationContext = createContext({
    isOpen: true,
    currentPage: '',
    navigateTo: (target) => {},
    toggleNavigation: (value = undefined) => {}
  })

export default navigationContext